import { useQuery } from '@tanstack/react-query';
import { Link } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';

import { cn } from '@nucleus-commerce/ui/lib/utils';

import { orderQueryOptions } from '../hooks/use-order';

/**
 * Links to an order by id. With `name` the label is known up front; without it the (cached) order
 * is read to show its name.
 */
export function OrderLink({
  storeId,
  orderId,
  name,
  className,
}: {
  storeId: string;
  orderId: string;
  name?: string | null;
  className?: string;
}) {
  const { t } = useTranslation('orders');
  const { data } = useQuery({ ...orderQueryOptions(storeId, orderId), enabled: !name });
  return (
    <Link
      to="/s/$storeId/orders/$orderId"
      params={{ storeId, orderId }}
      className={cn('font-mono text-[13px] hover:underline', className)}
      onClick={(e) => e.stopPropagation()}
    >
      {name ?? data?.name ?? t('link.view')}
    </Link>
  );
}
